module.exports = __webpack_public_path__ + "img/Banner_Kiosco_SUSP.f06e6b05.png";